/* shto-scp-pdp-sticky: the product page's sticky add to cart bar.
   Shows once the buy box's add button has scrolled above the screen and hides when it comes back. Checked on scroll and
   resize (one check per frame) plus an IntersectionObserver, so no state is missed. Without a buy box on the page it
   shows after the first screen of scrolling.
   Follows the buy box's variant: the shto:pdp-variant event (variantId, available, price, priceHtml, title, image) and,
   at load, the variant id in the buy box's form. Its button presses the buy box's add button (one add path: the theme's
   <product-form>). Without a buy box it makes its own <product-form> from its <template> and submits that.
   Never touches the address. */
(function () {
  var BUY = '[data-shto-section="shto-scp-pdp-buy"]';

  function ensureProductForm(root) {
    if (customElements.get('product-form') || document.querySelector('script[data-shto-productjs]')) return;
    var s = document.createElement('script');
    s.src = root.dataset.productjs;
    s.defer = true;
    s.setAttribute('data-shto-productjs', '');
    document.head.appendChild(s);
  }

  function sized(url, w) {
    if (!url) return '';
    var u = url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function textOf(html) {
    if (html == null) return '';
    return new DOMParser().parseFromString(String(html), 'text/html').body.textContent.trim();
  }

  function init(root) {
    if (root.dataset.shtoStickyOn) return;
    root.dataset.shtoStickyOn = '1';

    var variants = {};
    try { variants = JSON.parse(root.querySelector('[data-shto-pdp-sticky-variants]').textContent); } catch (e) {}
    var titleEl = root.querySelector('[data-shto-pdp-sticky-title]');
    var priceEl = root.querySelector('[data-shto-pdp-sticky-price]');
    var img = root.querySelector('.shto-scp-pdp-sticky-img');
    var add = root.querySelector('[data-shto-pdp-sticky-add]');
    var label = root.querySelector('[data-shto-pdp-sticky-label]');
    var heading = root.dataset.heading || '';
    var current = null;

    function buyBox() { return document.querySelector(BUY); }
    function buyButton() { return document.querySelector(BUY + ' [data-shto="add-to-cart"]'); }

    function setVariant(d) {
      var v = variants[String(d.variantId)] || {};
      current = String(d.variantId || current || '');
      var available = d.available != null ? !!d.available : !!v.available;
      if (titleEl) titleEl.textContent = heading ? heading.split('[option]').join(v.option || '') .trim() : root.dataset.productTitle;
      var price = d.priceHtml != null ? textOf(d.priceHtml) : v.price;
      if (priceEl && price) priceEl.textContent = price;
      var src = d.image || v.image;
      if (img && src) {
        var next = sized(src, 112);
        if (img.getAttribute('src') !== next) {
          img.setAttribute('srcset', sized(src, 56) + ' 56w, ' + sized(src, 96) + ' 96w, ' + next + ' 112w');
          img.setAttribute('src', next);
        }
        img.hidden = false;
      }
      if (add) {
        add.disabled = !available;
        if (label) label.textContent = available ? root.dataset.label : root.dataset.soldout;
      }
      var idInput = root.querySelector('[data-shto-pdp-sticky-id]');
      if (idInput && d.variantId) idInput.value = d.variantId;
    }

    // At load: whatever variant the buy box's form already holds.
    function syncFromBuyBox() {
      var box = buyBox();
      var id = box && box.querySelector('form [name="id"]');
      if (id && id.value && variants[id.value]) setVariant({ variantId: id.value });
    }
    syncFromBuyBox();
    document.addEventListener('shto:pdp-variant', function (e) { if (e.detail) setVariant(e.detail); });

    // Show / hide.
    var shown = false;
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      root.classList.toggle('is-shown', on);
      root.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) root.removeAttribute('inert'); else root.setAttribute('inert', '');
    }
    function check() {
      if (root.dataset.shtoStickyEditor) return setShown(true);
      var btn = buyButton();
      if (btn && btn.getClientRects().length) return setShown(btn.getBoundingClientRect().bottom < 0);
      setShown(window.scrollY > window.innerHeight);
    }
    var queued = false;
    function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; check(); }); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    var observed = null;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(queue) : null;
    function watch() {
      var btn = buyButton();
      if (io && btn && btn !== observed) { if (observed) io.unobserve(observed); io.observe(btn); observed = btn; }
      queue();
    }
    watch();
    document.addEventListener('shopify:section:load', function () { watch(); syncFromBuyBox(); });

    // Theme editor: the bar shows while its section is selected.
    document.addEventListener('shopify:section:select', function (e) { if (root.closest('#shopify-section-' + e.detail.sectionId)) { root.dataset.shtoStickyEditor = '1'; queue(); } });
    document.addEventListener('shopify:section:deselect', function (e) { if (root.closest('#shopify-section-' + e.detail.sectionId)) { delete root.dataset.shtoStickyEditor; queue(); } });

    // One click = one add.
    var busy = false;
    var timer = null;
    function done() { busy = false; clearTimeout(timer); if (add) { add.classList.remove('is-busy'); add.removeAttribute('aria-busy'); } }
    document.addEventListener('cart:item-added', done);
    document.addEventListener('product:variant-error', done);

    var form = null;
    function ownForm() {
      if (form) return form;
      var tpl = root.querySelector('template[data-shto-pdp-sticky-fallback]');
      if (!tpl) return null;
      ensureProductForm(root);
      root.appendChild(tpl.content.cloneNode(true));
      form = root.querySelector('form');
      var idInput = root.querySelector('[data-shto-pdp-sticky-id]');
      if (idInput && current && variants[current]) idInput.value = current;
      // Both the theme's handler and this one sit on the form: only stopImmediatePropagation keeps theirs from a second run.
      form.addEventListener('submit', function (e) {
        if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        busy = true;
      }, true);
      return form;
    }

    if (add) add.addEventListener('click', function () {
      if (add.disabled || busy) return;
      var btn = buyButton();
      if (btn) {
        if (btn.disabled) return;
        busy = true;
        add.classList.add('is-busy');
        add.setAttribute('aria-busy', 'true');
        timer = setTimeout(done, 8000);
        btn.click();
        return;
      }
      var f = ownForm();
      if (!f) return;
      add.classList.add('is-busy');
      add.setAttribute('aria-busy', 'true');
      timer = setTimeout(done, 8000);
      if (customElements.get('product-form')) f.requestSubmit();
      else customElements.whenDefined('product-form').then(function () { setTimeout(function () { f.requestSubmit(); }, 0); });
    });
  }

  // The Gorgias chat launcher sat on top of the bar's button. With "Hide the chat bubble" on, ask Gorgias to hide it on
  // this page through its own script API (Gorgias's documented ready pattern: init() when the widget is already there,
  // else its gorgias-widget-loaded event). Nothing is stored: every other page keeps the bubble.
  var chatHidden = false;
  function hideChat() {
    if (chatHidden) return;
    chatHidden = true;
    function go() { try { if (window.GorgiasChat && window.GorgiasChat.hideChat) window.GorgiasChat.hideChat(true); } catch (e) {} }
    function ready() { try { return window.GorgiasChat.init(); } catch (e) { return Promise.resolve(); } }
    if (window.GorgiasChat && window.GorgiasChat.init) ready().then(go, go);
    else window.addEventListener('gorgias-widget-loaded', function () { ready().then(go, go); }, { once: true });
  }

  function boot() {
    document.querySelectorAll('[data-shto-pdp-sticky]').forEach(function (root) {
      init(root);
      if (root.hasAttribute('data-hide-chat')) hideChat();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
